module.exports = __webpack_public_path__ + "img/No_Available_Data.672da385.svg";